import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 5000,
});

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

// ── Un compte admin existe-t-il déjà ? ────────────────────────
export const getAuthStatus = () =>
  api.get('/api/auth/status').then(r => r.data);

// ── Créer le tout premier compte administrateur ───────────────
export const setupFirstAdmin = (username, password, email) =>
  api.post('/api/auth/setup', { username, password, email: email || null }).then(r => r.data);

// ── Connexion (le champ "username" accepte le nom d'utilisateur OU l'email) ─
export const login = (username, password) =>
  api.post('/api/auth/login', { username, password }).then(r => r.data);

// ── Profil de l'utilisateur connecté ──────────────────────────
export const getMe = (token) =>
  api.get('/api/auth/me', authHeader(token)).then(r => r.data);

// ── Liste des comptes (admin ou plus) ──────────────────────────
export const getUsers = (token) =>
  api.get('/api/auth/users', authHeader(token)).then(r => r.data);

// ── Rôles que l'utilisateur connecté a le droit d'attribuer ────
export const getAssignableRoles = (token) =>
  api.get('/api/auth/roles', authHeader(token)).then(r => r.data);

// ── Créer un compte (rôle : admin | debutant | intermediaire | avance) ─
export const createUser = (token, username, password, role, email) =>
  api.post(
    '/api/auth/users',
    { username, password, role, email: email || null },
    authHeader(token)
  ).then(r => r.data);

// ── Supprimer un compte (admin uniquement) ────────────────────
export const deleteUser = (token, userId) =>
  api.delete(`/api/auth/users/${userId}`, authHeader(token)).then(r => r.data);

// ── Extrait un message d'erreur lisible depuis une erreur axios ─
export const getErrorMessage = (error, fallback = "Une erreur est survenue.") =>
  error?.response?.data?.detail || fallback;
